import React, { memo, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../models/Common';

interface SubmissionAction {
  isDisabled: boolean;
  isDisabledActivate: boolean;
  handleRestore: () => void;
  isLoading: boolean;
  handleAction: () => void;
  label: string;
}

const SubmissionAction = ({ isDisabled, handleRestore, handleAction, isLoading, isDisabledActivate, label }) => {
  const { t } = useTranslation();
  const isFirstRender = useRef(true);
  const [isLoaded, setIsloaded] = useState(false);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else if (!isLoading) {
      setIsloaded(true);
    } else if (isLoading) {
      setIsloaded(false);
    }
  }, [isLoading]);

  return (
    <>
      {isDisabled ? (
        <CustomMUIButton
          isLoading={!isLoaded}
          label={t('buttons.restore')}
          handleClick={handleRestore}
          className={ButtonClassNames.PrimaryFulfilled}
        />
      ) : (
        <CustomMUIButton
          label={label}
          handleClick={handleAction}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
          isLoading={!isLoaded}
          isDisabled={isDisabledActivate}
        />
      )}
    </>
  );
};

export default memo(SubmissionAction);
